"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { ArrowRight, ShieldCheck, Zap, Target, Users, Clock } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
export default function Aboutpineplayerz() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const advantages = [{
    id: "About Us",
    tag: "UAE",
    title: "Affan Waheed Co-Founder\nHassan Waheed Co-Founder",
    description: "The founders have over 7 years of experience in this business.",
    icon: ShieldCheck
  }];
  return <section ref={sectionRef} id="about-us" className="bg-background text-foreground relative overflow-hidden py-24 md:py-40 px-6 md:px-12 lg:px-20">
      {}
      <div className="absolute top-12 left-6 md:left-12 lg:left-20 font-mono text-xs tracking-widest text-primary/40">[03] About Us</div>

      {}
      <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-border/40">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-lg bg-primary" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-start">
          
          {}
          <div className={`lg:col-span-5 transition-all duration-1000 ease-out ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-8 h-px bg-primary" />
              <span className="font-mono text-xs tracking-[0.28em] uppercase text-primary">ABOUT PINE PLAYERZ MEDIA</span>
            </div>

            <h2 className="font-default font-bold text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tighter mb-10 text-foreground">Built by creators. Focused on growth</h2>

            <p className="leading-relaxed text-muted-foreground mb-12 max-w-lg !font-sans !text-3xl !font-semibold !text-left">Pine Playerz Media is an influencer marketing agency helping brands scale through strategic creator partnerships, social media campaigns, and performance-driven marketing. Founded by Affan Waheed and Hassan Waheed. Our mission is to connect brands with the right creators to drive authentic engagement and measurable growth. From YouTube and Instagram to emerging platforms, we help businesses unlock the power of creator-led marketing</p>

            <div className="relative group inline-block">
              
            </div>
          </div>

          {}
          <div className={`lg:col-span-7 transition-all duration-1000 ease-out delay-300 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="flex items-center justify-between mb-6">
              <span className="tracking-[0.24em] uppercase !font-bold !text-4xl md:!text-7xl !font-mono !not-italic !m-0 !p-0 shadow text-secondary-foreground">FOUNDERS</span>
              
            </div>

            <div className="space-y-6">
              {advantages.map((item, i) => i === 0 ? <Card key={item.id} data-index={i} className="text-card-foreground flex flex-col gap-6 py-12 min-h-[400px] group relative border bg-card/50 transition-all duration-300 rounded-lg shadow-sm overflow-hidden !border-4 border-solid !border-[rgba(222,252,233,1)] hover:bg-primary/5">
                    <CardHeader className="pb-2">
                      <div className="flex items-center gap-4 mb-4">
                        <span className="font-mono text-xs tracking-widest text-primary/60">
                          {item.id}
                        </span>
                      </div>
                      <CardTitle className="font-semibold leading-tight !font-bold !font-mono text-sidebar-accent-foreground !p-0 !m-0 whitespace-pre-line !text-4xl">
                        {item.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-muted-foreground leading-relaxed max-w-xl !text-base">
                        {item.description}
                      </p>
                      <p className="mt-6 font-mono tracking-[0.2em] uppercase text-primary/80 border-t border-border/40 pt-4 !text-base">
                        Affan Waheed Co-Founder Hassan Waheed Co-Founder
                      </p>
                    </CardContent>
                    
                  </Card> : <div key={item.id} data-index={i} className="group relative py-8 border-t border-border/60 hover:bg-primary/5 transition-colors duration-300 px-4 -mx-4 rounded-lg">
                  <div className="flex flex-col md:flex-row md:items-start gap-6">
                    <div className="flex items-center gap-4 shrink-0">
                      <span className="font-mono text-xs tracking-widest text-primary/60">
                        {item.id}
                      </span>
                      <div className="p-2 rounded-md bg-primary/10 text-primary">
                        <item.icon className="w-5 h-5" />
                      </div>
                    </div>
                    
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-2">
                        <span className="font-mono text-[10px] tracking-widest text-primary uppercase bg-primary/10 px-2 py-0.5 rounded-sm">
                          {item.tag}
                        </span>
                        <h3 className="font-default font-semibold text-foreground !text-left !text-2xl ![margin:0px_19px_0px_19px] ![padding:0px_0px_5px_0px]">
                          {item.title}
                        </h3>
                      </div>
                      <p className="text-muted-foreground text-sm leading-relaxed max-w-xl">
                        {item.description}
                      </p>
                    </div>

                    <div className="hidden md:block opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <ArrowRight className="w-5 h-5 text-primary" />
                    </div>
                  </div>
                </div>)}

              

              <Card className="py-6 text-card-foreground flex flex-col gap-6 min-h-[300px] group relative border bg-card/50 transition-all duration-300 shadow-sm overflow-hidden !border-4 border-solid !border-[rgba(222,252,233,1)] !py-6 md:![padding:100px_0px_48px_0px] rounded-lg mt-[200px] !h-auto md:!h-[400px] lg:!h-[500px] hover:bg-primary/5">
                <CardHeader className="pb-2">
                  <CardTitle className="leading-none font-semibold tracking-tighter text-primary mb-4 uppercase !font-semibold !text-3xl md:!text-5xl lg:!text-6xl !not-italic !overline !font-mono">
                    OUR MISSION
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="leading-tight tracking-tight !font-semibold !text-xl md:!text-2xl lg:!text-4xl !not-italic !text-[rgba(223,227,231,1)]">
                    "Our mission is to help brands harness the power of creator-driven growth and build authentic connections with audiences worldwide."
                  </p>
                  <p className="mt-6 font-mono text-sm tracking-widest uppercase text-primary">
                    — Affan Waheed & Hassan Waheed
                  </p>
                </CardContent>
              </Card>

              <Separator className="bg-border/60" />
            </div>

            {}
            
          </div>

        </div>
      </div>
    </section>;
}